import { Theme } from '@mui/material';
import {
    WbGrid,
    WbGridCol,
    WbGridRow,
    WbHeading,
    WbLink,
    WbTable,
    WbTableCell,
    WbTableHeader,
    WbTableRow,
    WbText,
} from '@workbench/react';
import { makeStyles } from 'tss-react/mui';
import { FormattedMessage } from 'react-intl';
import { useTranslation } from '../../common/i18n/useTranslation';
import { UrlsCollection } from '../../utils/links';
import fossThirdPartyLicensesJson from '../../assets/foss_third_party.json';

const useStyles = makeStyles()((theme: Theme) => ({
    gridContainer: {
        width: '100%',
        display: 'grid',
        gap: theme.spacing(3),
    },
}));

export default function ThirdPartyLicenseNoticesTab() {
    const { classes } = useStyles();
    const translate = useTranslation();
    const thirdPartyLicenses = fossThirdPartyLicensesJson;

    return (
        <WbGrid className={classes.gridContainer}>
            <WbGridRow>
                <WbGridCol mq1={12}>
                    <WbHeading size="s">{translate('copyright_notices_and_licenses')}</WbHeading>
                </WbGridCol>
            </WbGridRow>
            <WbGridRow>
                <WbGridCol mq1={12}>
                    <FormattedMessage
                        id="ThirdPartyLicenseNoticesPoint1"
                        defaultMessage="ThirdPartyLicenseNoticesPoint1"
                        values={{
                            mail: (
                                <WbLink variant="inline" href={`mailto:${UrlsCollection.Provider_MAIL_ADDRESS}`}>
                                    {UrlsCollection.Provider_MAIL_ADDRESS}
                                </WbLink>
                            ),
                        }}
                    />
                    <br />
                    <br />
                    <WbText size="l">{translate('ThirdPartyLicenseNoticesPoint2')}</WbText>
                    <br />
                    <br />
                    <WbTable lined="all">
                        <WbTableRow>
                            <WbTableHeader>{translate('component_name')}</WbTableHeader>
                            <WbTableHeader>{translate('version')}</WbTableHeader>
                            <WbTableHeader>{translate('licenses')}</WbTableHeader>
                            <WbTableHeader>{translate('copyright')}</WbTableHeader>
                        </WbTableRow>
                        {thirdPartyLicenses.components.map((component, index) => (
                            <WbTableRow key={index}>
                                <WbTableCell>
                                    <WbText>{component.name}</WbText>
                                </WbTableCell>
                                <WbTableCell>
                                    <WbText>{component.version}</WbText>
                                </WbTableCell>
                                <WbTableCell>
                                    <WbText>{component.licenseName}</WbText>
                                </WbTableCell>
                                <WbTableCell>
                                    <WbText>{component.copyright}</WbText>
                                </WbTableCell>
                            </WbTableRow>
                        ))}
                    </WbTable>
                </WbGridCol>
            </WbGridRow>
        </WbGrid>
    );
}
